import {onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, signOut, User} from 'firebase/auth';
import {auth, googleProvider} from './firebase';

export async function signInWithGoogle(): Promise<User> {
  const result = await signInWithPopup(auth, googleProvider);
  return result.user;
}

export async function signInWithEmail(email: string, password: string): Promise<User> {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return result.user;
}

export async function logout(): Promise<void> {
  await signOut(auth);
}

export function onAuthChange(callback: (user: User | null) => void): () => void {
  return onAuthStateChanged(auth, callback);
}

export async function isAdmin(user: User): Promise<boolean> {
  // Check custom claims for admin flag
  const tokenResult = await user.getIdTokenResult();
  return tokenResult.claims.admin === true;
}

export function getCurrentUser(): User | null {
  return auth.currentUser;
}
